import { SET_MENU_MANAGEMENT_REMOTE_CONFIG } from '../types/menuManagementRemoteConfig';

export type MenuManagementRemoteConfigPayload = {
  paramKey: string;
  raw: string;
  data: unknown;
  error: string | null;
  loaded: boolean;
};

export function setMenuManagementRemoteConfig(
  payload: MenuManagementRemoteConfigPayload,
) {
  return {
    type: SET_MENU_MANAGEMENT_REMOTE_CONFIG,
    payload,
  };
}
